import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ControlledMinMaxDonation from '@/components/common/form/ControlledMinMaxDonation';
import ControlledMinMaxHours from '@/components/common/form/ControlledMinMaxHours';
import DonationTypeSelect from '@/components/common/form/DonationTypeSelect';
import LabelSelect from '@/components/common/form/LabelSelect';
import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import TemporaryFilterField from '../constants/TemporaryFilterField';
import type ConstituentFilterFormData from '../types/ConstituentFilterFormData';

const MIN_MAX_CLASSES = {
  formControl: 'mb-0',
};

export default function QuickFiltersContribution() {
  const { control } = useFormContext<ConstituentFilterFormData>();

  return (
    <div className="grid w-80 grid-cols-1 gap-3 px-2 py-3">
      <Controller
        control={control}
        name={ConstituentSearchFilterField.DONATION_TYPES}
        render={({ field: { onChange, value } }) => (
          <DonationTypeSelect onChange={onChange} value={value} />
        )}
      />
      <ControlledMinMaxDonation
        classes={MIN_MAX_CLASSES}
        minName={`${TemporaryFilterField.DONATION_AMOUNT_RANGE}.0`}
        maxName={`${TemporaryFilterField.DONATION_AMOUNT_RANGE}.1`}
      />
      <ControlledMinMaxHours
        classes={MIN_MAX_CLASSES}
        minName={`${TemporaryFilterField.DONATION_HOURS_RANGE}.0`}
        maxName={`${TemporaryFilterField.DONATION_HOURS_RANGE}.1`}
      />
      <Controller
        control={control}
        name={TemporaryFilterField.CONTRIBUTION_LABELS}
        render={({ field: { onChange, value } }) => (
          <LabelSelect value={value} onChange={onChange} disableCloseOnSelect />
        )}
      />
    </div>
  );
}
